import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ResourceMatcherResource } from '@app/apps/bs-app-launch-form/bs-app-launch-form-controls/bs-app-launch-resource-matcher-control/resource-matcher.control';
import { SearchResourceType } from '@app/core/model/search/search-resource-type';

@Component({
  selector: 'app-resource-drop-slot',
  templateUrl: './resource-drop-slot.component.html',
  styleUrls: ['./resource-drop-slot.component.scss']
})
export class ResourceDropSlotComponent {
  @Input() resource: ResourceMatcherResource | null = null;
  @Input() resourceType: SearchResourceType;
  @Input() columnId: string = '';
  @Input() rowIndex: number = 0;
  @Input() isDragOver: boolean = false;

  @Output() resourceRemoved = new EventEmitter<{ rowIndex: number; columnId: string }>();
  
  get isBiosampleLibraryPrep(): boolean {
    return this.resourceType === SearchResourceType.BiosampleLibraryPrep;
  }

  constructor() {}

  get isEmpty(): boolean {
    return !this.resource;
  }

  get biosampleName(): string {
    return this.resource.name ? this.resource.name.split('::')[0] : '';
  }

  get libraryPrepName(): string {
    return this.resource.name ? this.resource.name.split('::')[1] : '';
  }

  removeResource(event: Event): void {
      event.stopPropagation();
      this.resourceRemoved.emit({
        rowIndex: this.rowIndex,
        columnId: this.columnId
      });
  }
}
